import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleProduct } from '../../../redux/action/product/singleProduct'
import MainLoading from '../../../utils/MainLoading'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import './style.scss'
import moment from "moment-jalaali";
import axios from 'axios'
import DashboardEditSingleProduct from './DashboardEditSingleProduct'
import { toast } from 'react-toastify'
import DashboardProductPhoto from './DashboardProductPhoto'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const DashboardSingleProduct = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const dispatch = useDispatch()
    const product = useSelector(state => state.single_product)
    const [deleteThisProduct, setDeleteThisProduct] = useState(false)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    const handleClose = () => { 
        setDeleteThisProduct(false) 
    }

    const handleDelete = (id) => {
        setDeleteThisProduct(true)
    }

    const update = () => {
        setShowEdit(false)
        setTimeout(function(){dispatch(fetchSingleProduct(props.match.params.id))}, 500)
    }

    const closeEdit = () => {
        setShowEdit(false)
    }

    const deleteProduct = () => {
        setBtnLoading(true)
        axios.delete(`co/product/${product.product.id}`)
        .then(res => {
            setBtnLoading(true)
            toast.dismiss()
            toast.success(t("toast_successfully_removed") , {position: 'bottom-right',className: 'foo-bar'})
            props.history.replace("/dashboard/categories") 
        })
        .catch(err => {
            console.log(err)
            toast.dismiss()
            toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
            setBtnLoading(true)
        })
    }

    const editProduct = () => {
        setShowEdit(true)
        window.scrollTo(0, 0)
    }

    useEffect(() => {
        dispatch(fetchSingleProduct(props.match.params.id))
    }, [props.match.params.id])


    return (
        <Wrapper>
            <DashboardContent>
                {product.loading ? 
                    <MainLoading />
                :
                    <>
                        {showEdit ?
                            <DashboardEditSingleProduct data={product} update={update} closeEdit={closeEdit} />
                        :
                        <>
                            <div className='d-flex justify-content-end'>
                                <Link to={`/dashboard/category-products/${product.product.category_id}`} className='btn btn-primary'>{t("return to categories")}</Link>
                            </div>
                            
                            <DashboardMainTitle> {product.product.name} </DashboardMainTitle>
                            <div className='single_product_container'>
                                <div className='single_product_item'><h4>{t("title")} : </h4><h1>{product.product.name}</h1></div>
                                <div className='single_product_item'><h4>{t("brand")} : </h4><h1>{product.product.brand}</h1></div>
                                <div className='single_product_item'><h4> {t("product_price")} : </h4><h1>{product.product.price && product.product.price === 0 ? t("free") : parseInt(product.product.price).toLocaleString()} ریال</h1></div>
                                <div className='single_product_item'><h4>{t("product_selling_price")} : </h4><h1>{product.product.sell_price && product.product.sell_price === 0 ? t("free") : parseInt(product.product.sell_price).toLocaleString()}  ریال</h1></div>
                                <div className='single_product_item'><h4> {t("view counts")} : </h4><h1>{product.product.view_count}</h1></div>
                                <div className='single_product_item'><h4> {t("last update")} : </h4>
                                    <h1>
                                        {lang === 'en' ?
                                            product.product.updated_at && product.product.updated_at.substr(11, 5)+' - '+product.product.updated_at && product.product.updated_at && product.product.updated_at.substr(0, 10)
                                        :
                                            product.product.updated_at && product.product.updated_at.substr(11, 5)+' - '+product.product.updated_at && moment(product.product.updated_at && product.product.updated_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                        }
                                    </h1>
                                </div>
                                
                                <DashboardProductPhoto data={product} id={props.match.params.id} update={update} />
                                
                                <div className="col-12 create_btn mt-5">
                                <button className="btn btn-danger mx-1" onClick={handleDelete}> {t("delete")} </button>
                                    <button className="btn btn-success" onClick={editProduct}> {t("edit")} </button>
                                </div>
                            </div>
                        </>
                        }
                    </>
                }
            </DashboardContent>
                {deleteThisProduct ? 
                    <Modal show={deleteThisProduct} onHide={handleClose}>
                        <Modal.Header>
                            <Modal.Title> {t("delete this item")} </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                {t("Cancel")}
                            </Button>
                            <Button variant="danger" onClick={deleteProduct} disabled={btnLoading ? true : false}>
                                {t("confirm")}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                : ''}
        </Wrapper>
    )
}

export default DashboardSingleProduct
